import React from 'react';
import { InlineEdit, InlineEditTableWrapper } from '@nile/components';
import InlineDependantSelect from '@nile/components/src/Components/InlineEdit/Components/InlineDependantSelect';

function InlineEditTextCell(props) {
  const { _ticket, cell } = props;
  const ticket = _ticket || cell.row.original;
  const { actions, type, editable, clearable, shouldFreezeCell } = cell.column;
  const CELL_TYPE = type === 'Status' ? 'tag' : '';
  const isCellFreezed = shouldFreezeCell && shouldFreezeCell(cell);
  return (
    <>
      <InlineEditTableWrapper
        className="full-width"
        key={ticket?.ticketId || cell?.field?.name || cell?.row?.id}
      >
        <InlineEdit
          editable={!isCellFreezed && editable}
          autoSave
          showProgress
          editView={(fieldProps) => {
            return (
              <>
                <InlineDependantSelect
                  {...props}
                  mode="edit"
                  updateFieldState={fieldProps.updateFieldState}
                  isClearable={clearable}
                />
              </>
            );
            // return <div>{defaultValue?.label || 'NA'}</div>;
          }}
          readView={() => {
            return (
              <InlineDependantSelect {...props} mode="view" type={CELL_TYPE} />
            );
          }}
          onConfirm={(value, callback) => {
            actions.save && actions.save(value, ticket, props.data, callback);
            // updateCell(value, null, null, callback);
          }}
        />
      </InlineEditTableWrapper>
    </>
  );
}

export default InlineEditTextCell;
